import React, { createContext, useContext } from 'react';

// The credits/tokens system has been retired — every AI action is now free
// and unlimited. This provider is kept as a no-op so existing consumers of
// `useTokens()` keep working without change (they just never gate anything).

const TokenContext = createContext(null);

const NOOP_TOKENS = {
  balance: Infinity,
  planType: 'unlimited',
  canAfford: () => true,
  deductTokens: () => true,
  addTokens: () => {},
};

export function TokenProvider({ children }) {
  return (
    <TokenContext.Provider value={NOOP_TOKENS}>
      {children}
    </TokenContext.Provider>
  );
}

export function useTokens() {
  return useContext(TokenContext) || NOOP_TOKENS;
}
